import { useState as m, useRef as P, useCallback as u, useId as O } from "react";
import { getOwnerDocument as w } from "../../utils/dom/index.js";
import { focus as A } from "../../utils/focus/index.js";
import { useMenuDescendants as B } from "./useMenuDescendantsContext.js";
import { useDisclosure as L } from "../../utils/hooks/useDisclosure.js";
import { useOnClickOutside as $ } from "../../utils/hooks/useOnClickOutside.js";
import { useChangeEffect as H } from "../../utils/hooks/useChangeEffect.js";
import { useFocusOnHide as U } from "../../utils/hooks/useFocusOnHide.js";
import { useUnmountEffect as W } from "../../utils/hooks/useUnmountEffect.js";
const V = (g = {}) => {
  const {
    opened: C,
    onClose: F,
    onOpen: R,
    closeOnSelect: b = !0
  } = g, [s, h] = m(null), [f, x] = m(null), o = B(), r = P(/* @__PURE__ */ new Set([])), [d, i] = m(-1), l = u(() => {
    const e = setTimeout(() => {
      const t = o.firstEnabled();
      t && i(t.index);
    });
    r.current.add(e);
  }, [o]), a = u(() => {
    const e = setTimeout(() => {
      const t = o.lastEnabled();
      t && i(t.index);
    });
    r.current.add(e);
  }, [o]), { opened: n, onOpen: c, onClose: p, onToggle: T } = L({
    opened: C,
    onClose: F,
    onOpen: R
  });
  $(
    s,
    (e) => {
      const t = document.contains(e.target), I = !f?.contains(e.target);
      t && I && p();
    },
    n
  ), H(() => {
    n || i(-1);
  }, [n]), U(
    { current: s },
    {
      focusRef: { current: f },
      visible: n,
      shouldFocus: !0
    }
  );
  const M = `menu-button-${O()}`, S = `menu-list-${O()}`;
  W(() => {
    r.current.forEach((e) => clearTimeout(e)), r.current.clear();
  });
  const k = u(() => {
    c(), l();
  }, [l, c]), v = u(() => {
    c(), a();
  }, [c, a]), D = u(() => {
    const e = w(s), t = s?.contains(e.activeElement);
    if (!(n && !t))
      return;
    const E = o.item(d)?.node;
    E && A(E, { selectTextIfInput: !1, preventScroll: !1 });
  }, [s, n, d, o]);
  return {
    openAndFocusFirstItem: k,
    openAndFocusLastItem: v,
    onTransitionEnd: D,
    // Can be used in case there is an open CSS animation of MenuList
    descendants: o,
    buttonId: M,
    menuId: S,
    orientation: "vertical",
    opened: n,
    onToggle: T,
    onOpen: c,
    onClose: p,
    menuRef: s,
    setMenuRef: h,
    buttonRef: f,
    setButtonRef: x,
    focusedIndex: d,
    setFocusedIndex: i,
    closeOnSelect: b
  };
};
export {
  V as useMenu
};
//# sourceMappingURL=useMenu.js.map
